import SessionUniquenessError from './SessionUniquenessError';

export default SessionUniquenessError;